import { useEffect, useState } from "react";
import type { AuthContextProps } from "react-oidc-context";
import { Events } from "../assets/services/Events.ts";
import type { PontoEvent } from "../assets/types/PontoEvent.ts";


export function useEvents(auth: AuthContextProps) {
    const [events, setEvents] = useState<PontoEvent[] | undefined>(undefined);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (auth.isAuthenticated && !loaded) {
            const eventsInstance = new Events(auth);
            eventsInstance.initialize().then(() => {
                setEvents(eventsInstance.get());
                setLoaded(true);
            });
        }
    }, [auth, loaded]);

    return { events, loaded };
}
